import { useEffect } from "react";
import { v4 } from "uuid";
import produce from "immer";
import { renameFile } from "../../../../utils/files";
import { handleLargeFilesError, isTooLarge } from "./utils";

const useClipboardPaste = (
  listenerTarget: HTMLElement | null, // null pred inicializaci ref
  onPaste?: (files: File[]) => void
) => {
  useEffect(() => {
    if (!listenerTarget) return undefined;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listenerCallback = (e: any) => {
      if (!onPaste) return;

      const items = (e.clipboardData || e.originalEvent.clipboardData)?.items;
      if (!items?.length) return;

      const files = [] as File[];
      const declinedFileNames = [];

      for (let i = 0; i < items.length; i += 1) {
        const fileAttempt = items[i].getAsFile() as File; // z nějakých security důvodů nelze číst clipboard napřímo, nutno použít getAsFile()
        if (fileAttempt === null) return; // Když neni file

        if (isTooLarge(fileAttempt)) {
          declinedFileNames.push(fileAttempt.name);
        } else {
          const name = `Clipboard image - ${v4()}`; // Přejmenuju, bo jinak se opakuje jméno pasted file
          const renamedFile = renameFile(fileAttempt, name);
          files.push(renamedFile);
        }
      }

      if (declinedFileNames.length) {
        handleLargeFilesError(declinedFileNames);
      }

      onPaste(files);
    };

    listenerTarget.addEventListener("paste", listenerCallback);
    return () => listenerTarget.removeEventListener("paste", listenerCallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listenerTarget]);
};

export default useClipboardPaste;
